module.exports = __webpack_public_path__ + "static/img/wa05.177fc020.png";